@if(form) {
<section class="py-6 border-b border-b-shs-gray-4" [formGroup]="form">
    <h2 class="text-base font-bold text-font-primary">Affected Items</h2>
    <div class="mt-4 flex flex-col gap-4">
        <sag-ui-select
            [required]="true"
            [label]="selectLabel"
            [placeholder]="selectPlaceholder"
            [value]="form.get(formControlName)?.value"
            [disabled]="disabled"
            (change)="handleSelectChange($event)"
            class="max-w-input"
        >
            @for (item of items; track $index) {
            <sag-ui-option [value]="item">{{ item }}</sag-ui-option>
            }
        </sag-ui-select>
        @if(!hideOrderLineTable) {
        <app-order-line-table
            [selected]="lineItems"
            [disabled]="disabled"
            [currency]="isDomestic() ? 'USD' : 'EUR'"
            (selectionChange)="handleSelectionChange($event)"
        ></app-order-line-table>
        @if (!disabled) {
        <div class="flex items-center justify-end max-w-[1400px]">
            <sag-ui-button [disabled]="!valid || confirmed" (click)="setConfirmed()" size="sm">{{
                confirmed ? 'Confirmed' : 'Confirm'
            }}</sag-ui-button>
        </div>
        } }
    </div>
</section>
}
